/** Classes the utilization table's rows and its total rows share. */

// Separates the two things the table reports: what happened (Description,
// Count) and what it cost (Minutes, Price, Amount). Applied to the Minutes
// column in every row, header and total alike, so the rule runs unbroken.
export const COST_COLUMN_DIVIDER = 'border-l border-border pl-4'

// Keeps the count off the rule it sits against.
export const COUNT_COLUMN = 'pr-4'
